import { getRegionalizedLocale } from "app/language/tools/common"
import { getStore } from "app/store/store"

// in the result tuple: first is thousand separator, second is decimal separator
export function getNumberSeparators(): [string, string] {
  // Ex. getFormatedNumber(1000.1) : "en" => "1,000.1" ; "fr" => "1 000,1"
  const stringNumber = getFormatedNumber(1000.1)
  return [stringNumber[1], stringNumber[5]]
}

export function getFormatedNumber(num: number): string {
  if (typeof num !== "number") {
    return num
  }
  return num.toLocaleString(getStore().getState().language.locale)
}

export function getCompactFormattedNumber(toFormatNumber: number): string {
  if (toFormatNumber < 1000000) {
    return getFormatedNumber(Number(toFormatNumber.toFixed()))
  }
  return new Intl.NumberFormat(getRegionalizedLocale(), { notation: "compact", compactDisplay: "long" }).format(
    toFormatNumber
  )
}
